import { FC, MouseEventHandler } from 'react';
import { useIntl } from 'react-intl';
import { Hyperlink } from '@ebsco-ui/ebsco-ui';

import { sharedMessages } from '@app/translations';
import { ShapeWithClassName } from '@app/constants';

interface ExternalLinkProps {
  href: string;
  onClick?: MouseEventHandler;
}

export const ExternalLink: FC<ShapeWithClassName<ExternalLinkProps>> = ({
  children,
  href,
  className,
  onClick,
}) => {
  const { $t } = useIntl();

  return (
    <Hyperlink
      href={href}
      target="_blank"
      rel="noreferrer"
      className={className}
      onClick={onClick}
    >
      {children}{' '}
      <span className="visuallyHidden">{$t(sharedMessages.externalLink)}</span>
    </Hyperlink>
  );
};
